export default {
  base: '/chat/', // '/', // '/dist/', // for Widget mode, '/chat/' for release, '/' for local dev.
  enableWidgetMode: true, // 新增：控制是否啟用 widget 模式(User自動登入)
  NoIconToggle: true, // enableWidgetMode: true時，沒有Icon做toggle
  BaslcLogin: false, // 新增：控制是否啟用 Baslc 登入
  AISelection: true, // 新增：控制是否啟用 AI 選擇
  RepairingServerUrl: 'https://oidc.provider:7220',  // 'https://oidc.provider:5000/',
};
